import { AppBar, Box, Container, Stack, Toolbar, Typography } from '@mui/material';
import { motion } from 'framer-motion';

export default function SiteLayout({ children }) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        color: 'text.primary',
        position: 'relative',
        overflow: 'hidden',
        background:
          'radial-gradient(circle at 8% -5%, rgba(192, 132, 252, 0.26) 0%, transparent 42%), radial-gradient(circle at 90% 8%, rgba(155, 77, 202, 0.28) 0%, transparent 38%), linear-gradient(160deg, #10071c 0%, #1a0d2e 45%, #22103b 100%)',
      }}
    >
      <Box
        component={motion.div}
        initial={{ opacity: 0, scale: 0.92 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
        sx={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(0deg, rgba(255,255,255,0.02) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px)',
          backgroundSize: '28px 28px',
          maskImage: 'radial-gradient(circle at center, black 34%, transparent 86%)',
          pointerEvents: 'none',
        }}
      />

      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          background: 'linear-gradient(180deg, rgba(16,7,28,0.84), rgba(16,7,28,0.55))',
          borderBottom: '1px solid rgba(192,132,252,0.22)',
          backdropFilter: 'blur(14px)',
        }}
      >
        <Container maxWidth="xl">
          <Toolbar sx={{ minHeight: '76px', px: { xs: 0 } }}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Box
                sx={{
                  width: 14,
                  height: 14,
                  borderRadius: '5px',
                  transform: 'rotate(45deg)',
                  background: 'linear-gradient(135deg, #e6c6ff, #9b4dca)',
                  boxShadow: '0 0 0 7px rgba(155, 77, 202, 0.18)',
                }}
              />
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                AS212348
              </Typography>
            </Stack>

            <Box sx={{ ml: 'auto' }} />
          </Toolbar>
        </Container>
      </AppBar>

      <Box sx={{ height: 72 }} />
      {children}
    </Box>
  );
}
